interface LangFlagProps {
  /** Эмодзи-флаг локали (regional indicators), напр. '🇷🇺'. */
  flag: string;
  className?: string;
}

// Рендерит флаг локали шрифтом TwemojiFlags (класс .emoji-flag), чтобы флаги
// одинаково отображались во всех браузерах. Chrome на Windows/Linux не несёт
// flag-emoji глифов и без этого показывает буквы "GB/RU" вместо флага.
// Декоративен (aria-hidden): рядом всегда есть текст названия языка / aria-label.
export default function LangFlag({ flag, className }: LangFlagProps) {
  return (
    <span className={`emoji-flag${className ? ` ${className}` : ''}`} aria-hidden="true">
      {flag}
    </span>
  );
}
